module.exports = __webpack_public_path__ + "co.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/co.svg
// module id = 500
// module chunks = 0